var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.facet.name
    ? _c("div", { staticClass: "pt-4 border-0", class: _vm.facet.cssClass }, [
        _c("div", { staticClass: "h3 title py-0" }, [
          _vm._v(_vm._s(_vm.facetName))
        ]),
        _vm._v(" "),
        _vm.facet.type === "price"
          ? _c("div", [_c("item-filter-price")], 1)
          : _c("div", { staticClass: "dropdown" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary dropdown-toggle",
                  attrs: {
                    type: "button",
                    id: "dropdown-" + _vm._uid,
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.selectedOptions.length
                          ? _vm.selectedOptions.join(", ")
                          : "Auswählen"
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dropdown-menu",
                  attrs: { "aria-labelledby": "dropdown-" + _vm._uid }
                },
                _vm._l(_vm.facets, function(value) {
                  return _c(
                    "div",
                    {
                      key: value.id,
                      staticClass: "dropdown-item d-flex align-items-center",
                      class: { disabled: value.count <= 0 },
                      on: {
                        click: function($event) {
                          return _vm.toggleSelection(value)
                        }
                      }
                    },
                    [
                      _c("input", {
                        staticClass: "form-check-input mr-2",
                        attrs: {
                          type: "checkbox",
                          id: "option-" + value.id + "-" + _vm._uid,
                          disabled: _vm.isLoading || value.count <= 0
                        },
                        domProps: { checked: _vm.isSelected(value.id) },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "mb-0",
                          attrs: { for: "option-" + value.id + "-" + _vm._uid }
                        },
                        [
                          _c("span", {
                            staticClass: "flex-grow-1",
                            domProps: { innerHTML: _vm._s(value.name) }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "badge badge-secondary ml-2" },
                            [_vm._v(_vm._s(value.count))]
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }